"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _core = require("@material-ui/core");

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _ToggleButton = _interopRequireDefault(require("@material-ui/lab/ToggleButton"));

var _ToggleButtonGroup = _interopRequireDefault(require("@material-ui/lab/ToggleButtonGroup"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Checkbox = require("../Checkbox/Checkbox");

var _DateTimePicker = _interopRequireDefault(require("../DateTimePicker/DateTimePicker"));

var _DropDown = _interopRequireDefault(require("../DropDown/DropDown"));

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));

var _Toggle = _interopRequireDefault(require("../Toggle/Toggle"));

var _recurrenceTypes = require("./recurrenceTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Recurrence = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Recurrence, _React$Component);

  var _super = _createSuper(Recurrence);

  function Recurrence() {
    var _this;

    (0, _classCallCheck2.default)(this, Recurrence);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      type: _recurrenceTypes.recurrenceTypes.NONE,
      useNumberOfOccurrences: false,
      occurrences: "",
      until: null,
      interval: 1,
      daily: {},
      weekly: {
        weekdays: []
      },
      monthly: {
        weekdays: ["Sunday"],
        offset: "First",
        dayOfMonth: ""
      },
      yearly: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlers", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlerFor", function (name) {
      var noType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var valueAccessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (e) {
        return e.target.value;
      };
      // Here we are caching the handler functions so we don't recreate a new function every time we re-render.
      var type = _this.state.type === _recurrenceTypes.recurrenceTypes.DAILY ? "daily" : _this.state.type === _recurrenceTypes.recurrenceTypes.WEEKLY ? "weekly" : _this.state.type === _recurrenceTypes.recurrenceTypes.MONTHLY ? "monthly" : "yearly";

      if (_this.handlers[type] == null) {
        _this.handlers[type] = {};
      }

      if (noType) {
        if (_this.handlers[name] == null) {
          _this.handlers[name] = function (e) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            var value = valueAccessor.apply(null, [e, args]);

            _this.setState((0, _defineProperty2.default)({}, name, value), function () {
              _this.props.onChange && _this.props.onChange(_this.getStatePreparedForOnChange(), e);
              _this.props.executeValidation && _this.props.executeValidation();
            });
          };
        }

        return _this.handlers[name];
      }

      if (_this.handlers[type][name] == null) {
        _this.handlers[type][name] = function (e) {
          for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          var value = valueAccessor.apply(null, [e, args]);

          _this.setState((0, _defineProperty2.default)({}, type, _objectSpread(_objectSpread({}, _this.state[type]), {}, (0, _defineProperty2.default)({}, name, value))), function () {
            _this.props.onChange && _this.props.onChange(_this.getStatePreparedForOnChange(), e);
            _this.props.executeValidation && _this.props.executeValidation();
          });
        };
      }

      return _this.handlers[type][name];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUseNumberOfOccurrencesClick", function (e) {
      _this.setState({
        useNumberOfOccurrences: e.target.checked
      }, function () {
        _this.props.onChange && _this.props.onChange(_this.getStatePreparedForOnChange(), e);
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Recurrence, [{
    key: "getStatePreparedForOnChange",
    value: function getStatePreparedForOnChange() {
      var _this$state = this.state,
          useNumberOfOccurrences = _this$state.useNumberOfOccurrences,
          occurrences = _this$state.occurrences,
          until = _this$state.until,
          interval = _this$state.interval,
          weekly = _this$state.weekly,
          monthly = _this$state.monthly,
          type = _this$state.type; // All types use interval, and then either until or occurences, which is set in the return below.

      var newState = {
        type: type,
        interval: interval
      };

      if (newState.type === _recurrenceTypes.recurrenceTypes.WEEKLY) {
        // Weekly needs to make sure weekdays are set since the API requires them.
        newState = _objectSpread(_objectSpread({}, newState), weekly);
        newState.weekdays = newState.weekdays || [];
      }

      if (newState.type === _recurrenceTypes.recurrenceTypes.MONTHLY) {
        // Monthly sends conditional properties depending on the toggle.
        var useRepeatEach = monthly.useRepeatEach,
            offset = monthly.offset,
            dayOfMonth = monthly.dayOfMonth,
            weekdays = monthly.weekdays;

        if (useRepeatEach) {
          // weekdays must be provided to the API as an empty array for this case.
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            dayOfMonth: dayOfMonth,
            weekdays: []
          });
        } else {
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            offset: offset,
            weekdays: weekdays
          });
        }
      }

      return useNumberOfOccurrences ? _objectSpread(_objectSpread({}, newState), {}, {
        occurrences: occurrences
      }) : _objectSpread(_objectSpread({}, newState), {}, {
        until: until
      });
    } // This is a higher order helper function that takes a name and
    //   creates a handler to automatically assign into the state.
    //   The value accessor defaults to event.target.value but can be overridden
    // Example Usage: this.handlerFor("type") // assigns values to "type" on the state

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          required = _this$props.required,
          id = _this$props.id,
          error = _this$props.error;
      var _this$state2 = this.state,
          occurrences = _this$state2.occurrences,
          until = _this$state2.until,
          useNumberOfOccurrences = _this$state2.useNumberOfOccurrences;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "".concat(id, "-recurrence"),
        className: "prmbl-recurrence"
      }, /*#__PURE__*/_react.default.createElement(_DropDown.default, {
        id: "".concat(id, "-recurrence-type"),
        onChange: this.handlerFor("type", true, function (date) {
          return date ? date.value : _recurrenceTypes.recurrenceTypes.NONE;
        }),
        value: this.state.type,
        options: [{
          label: "None",
          value: _recurrenceTypes.recurrenceTypes.NONE
        }, {
          label: "Daily",
          value: _recurrenceTypes.recurrenceTypes.DAILY
        }, {
          label: "Weekly",
          value: _recurrenceTypes.recurrenceTypes.WEEKLY
        }, {
          label: "Monthly",
          value: _recurrenceTypes.recurrenceTypes.MONTHLY
        }, {
          label: "Yearly",
          value: _recurrenceTypes.recurrenceTypes.YEARLY
        }],
        label: "Recur",
        sortMenuOptions: false
      }), this.state.type === _recurrenceTypes.recurrenceTypes.DAILY && /*#__PURE__*/_react.default.createElement(DailyRecurrenceOptions, (0, _extends2.default)({
        required: required
      }, this.state, {
        handlerFor: this.handlerFor,
        id: id,
        error: error
      })), this.state.type === _recurrenceTypes.recurrenceTypes.WEEKLY && /*#__PURE__*/_react.default.createElement(WeeklyRecurrenceOptions, (0, _extends2.default)({}, this.state.weekly, {
        interval: this.state.interval,
        required: required,
        handlerFor: this.handlerFor,
        id: id,
        error: error
      })), this.state.type === _recurrenceTypes.recurrenceTypes.MONTHLY && /*#__PURE__*/_react.default.createElement(MonthlyRecurrenceOptions, (0, _extends2.default)({}, this.state.monthly, {
        interval: this.state.interval,
        required: required,
        handlerFor: this.handlerFor,
        id: id,
        error: error
      })), this.state.type === _recurrenceTypes.recurrenceTypes.YEARLY && /*#__PURE__*/_react.default.createElement(YearlyRecurrenceOptions, (0, _extends2.default)({
        required: required
      }, this.state, {
        handlerFor: this.handlerFor,
        id: id,
        error: error
      })), this.state.type !== _recurrenceTypes.recurrenceTypes.NONE && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
        label: "End After # of Occurrences?",
        id: "".concat(id, "-recurrence-use-number-of-occurrences-label"),
        control: /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
          id: "".concat(id, "-recurrence-use-number-of-occurrences"),
          onChange: this.onUseNumberOfOccurrencesClick,
          className: "prmbl-recurrence-useNumberOccurrences"
        })
      })), useNumberOfOccurrences && /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        id: "".concat(id, "-recurrence-number-of-occurrences"),
        className: "prmbl-recurrence-numberOfOccurrences",
        required: required,
        onChange: this.handlerFor("occurrences", true),
        label: "# of Occurrences",
        value: occurrences,
        type: "number",
        minValue: 1,
        maxValue: 52,
        error: error
      }), !useNumberOfOccurrences && /*#__PURE__*/_react.default.createElement(_DateTimePicker.default, {
        onChange: this.handlerFor("until", true),
        required: required,
        label: "Until",
        id: "".concat(id, "-recurrence-until-date"),
        className: "prmbl-recurrence-until",
        value: until,
        keyboard: true,
        error: error
      }), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
        id: "".concat(id, "-recurrence-helper-text-maximum-occurrences")
      }, "A maximum of 52 occurrences can be created.")));
    }
  }]);
  return Recurrence;
}(_react.default.Component);

(0, _defineProperty2.default)(Recurrence, "propTypes", {
  /**
   *  Triggered when recurrence information is updated. Used for sending updated recurrence information.   `function(newState, event: object) => void`
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * Function passed in from /Validation/index.js.. Used to bypass the checks inside index.js and call validation directly.
   */
  executeValidation: _propTypes.default.func,

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Boolean whether there is an error from validation
   */
  error: _propTypes.default.bool
});

var DailyRecurrenceOptions = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(DailyRecurrenceOptions, _React$Component2);

  var _super2 = _createSuper(DailyRecurrenceOptions);

  function DailyRecurrenceOptions() {
    (0, _classCallCheck2.default)(this, DailyRecurrenceOptions);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(DailyRecurrenceOptions, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          handlerFor = _this$props2.handlerFor,
          required = _this$props2.required,
          id = _this$props2.id,
          interval = _this$props2.interval,
          error = _this$props2.error;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        type: "number",
        id: "".concat(id, "-recurrence-interval"),
        className: "prmbl-recurrence-interval",
        onChange: handlerFor("interval", true),
        required: required,
        value: interval,
        error: error,
        minValue: 1,
        label: "Every X day(s)"
      }));
    }
  }]);
  return DailyRecurrenceOptions;
}(_react.default.Component);

(0, _defineProperty2.default)(DailyRecurrenceOptions, "propTypes", {
  /**
   * The number of [days,weeks,months,years] between each occurrence for the recurrence.
   */
  interval: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /*
   * If true the recurrence options are required.
   */
  required: _propTypes.default.bool,

  /*
   *  A function that will create a handler to handle value changes given a name and optional value accessor. (name, valueAccessor) => value => {...}
   */
  handlerFor: _propTypes.default.func,

  /**
   * Boolean whether there is an error from validation
   */
  error: _propTypes.default.bool
});

var WeeklyRecurrenceOptions = /*#__PURE__*/function (_React$Component3) {
  (0, _inherits2.default)(WeeklyRecurrenceOptions, _React$Component3);

  var _super3 = _createSuper(WeeklyRecurrenceOptions);

  function WeeklyRecurrenceOptions() {
    var _this2;

    (0, _classCallCheck2.default)(this, WeeklyRecurrenceOptions);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this2 = _super3.call.apply(_super3, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "daysOfTheWeek", {
      SUNDAY: "Sunday",
      MONDAY: "Monday",
      TUESDAY: "Tuesday",
      WEDNESDAY: "Wednesday",
      THURSDAY: "Thursday",
      FRIDAY: "Friday",
      SATURDAY: "Saturday"
    });
    return _this2;
  }

  (0, _createClass2.default)(WeeklyRecurrenceOptions, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          handlerFor = _this$props3.handlerFor,
          required = _this$props3.required,
          id = _this$props3.id,
          weekdays = _this$props3.weekdays,
          interval = _this$props3.interval,
          error = _this$props3.error;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        type: "number",
        id: "".concat(id, "-recurrence-interval"),
        className: "prmbl-recurrence-interval",
        onChange: handlerFor("interval", true),
        required: required,
        value: interval,
        label: "Every X week(s)",
        minValue: 1,
        error: error
      }), /*#__PURE__*/_react.default.createElement("div", null, "On", " ", /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        id: id,
        className: "prmbl-toggle-button-group",
        error: error,
        required: required
      }, /*#__PURE__*/_react.default.createElement(_ToggleButtonGroup.default, {
        id: "".concat(id, "-weekly-recurrence-toggle-buttons"),
        exclusive: false,
        required: required,
        onChange: function onChange(e, value) {
          if (weekdays.includes(value[0])) {
            var newValue = weekdays.filter(function (x) {
              return x !== value[0];
            });
            handlerFor("weekdays", false, function (value) {
              return value;
            })(newValue);
          } else {
            handlerFor("weekdays", false, function (value) {
              return value;
            })([].concat((0, _toConsumableArray2.default)(weekdays), (0, _toConsumableArray2.default)(value)));
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.SUNDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-sunday"),
        value: this.daysOfTheWeek.SUNDAY
      }, "S"), /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.MONDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-monday"),
        value: this.daysOfTheWeek.MONDAY
      }, "M"), /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.TUESDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-tuesday"),
        value: this.daysOfTheWeek.TUESDAY
      }, "T"), /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.WEDNESDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-wednesday"),
        value: this.daysOfTheWeek.WEDNESDAY
      }, "W"), /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.THURSDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-thursday"),
        value: this.daysOfTheWeek.THURSDAY
      }, "T"), /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.FRIDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-friday"),
        value: this.daysOfTheWeek.FRIDAY
      }, "F"), /*#__PURE__*/_react.default.createElement(_ToggleButton.default, {
        selected: weekdays.includes(this.daysOfTheWeek.SATURDAY),
        id: "".concat(id, "-weekly-recurrence-toggle-button-saturday"),
        value: this.daysOfTheWeek.SATURDAY
      }, "S"))), /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
        label: "Every Weekday",
        id: "".concat(id, "-recurrence-every-weekday-label"),
        control: /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
          id: "".concat(id, "-recurrence-every-weekday"),
          onChange: function onChange(e) {
            var checked = e.target.checked;
            var handlerFunction = handlerFor("weekdays", false, function (value) {
              return value;
            });
            var days = [_this3.daysOfTheWeek.MONDAY, _this3.daysOfTheWeek.TUESDAY, _this3.daysOfTheWeek.WEDNESDAY, _this3.daysOfTheWeek.THURSDAY, _this3.daysOfTheWeek.FRIDAY];

            if (checked) {
              var newValue = (0, _toConsumableArray2.default)(new Set([].concat(days, (0, _toConsumableArray2.default)(weekdays))));
              handlerFunction(newValue);
            } else {
              var _newValue = weekdays.filter(function (x) {
                return !days.includes(x);
              });

              handlerFunction(_newValue);
            }
          }
        })
      })));
    }
  }]);
  return WeeklyRecurrenceOptions;
}(_react.default.Component);

(0, _defineProperty2.default)(WeeklyRecurrenceOptions, "propTypes", {
  /**
   * The number of [days,weeks,months,years] between each occurrence for the recurrence.
   */
  interval: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /*
   * If true the recurrence options are required.
   */
  required: _propTypes.default.bool,

  /*
   *  A function that will create a handler to handle value changes given a name and optional value accessor. (name, valueAccessor) => value => {...}
   */
  handlerFor: _propTypes.default.func,

  /**
   * The selected weekdays for the recurrence.
   */
  weekdays: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Boolean whether there is an error from validation
   */
  error: _propTypes.default.bool
});

var MonthlyRecurrenceOptions = /*#__PURE__*/function (_React$Component4) {
  (0, _inherits2.default)(MonthlyRecurrenceOptions, _React$Component4);

  var _super4 = _createSuper(MonthlyRecurrenceOptions);

  function MonthlyRecurrenceOptions() {
    var _this4;

    (0, _classCallCheck2.default)(this, MonthlyRecurrenceOptions);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "repetitionOrdinals", {
      FIRST: "First",
      SECOND: "Second",
      THIRD: "Third",
      FOURTH: "Fourth",
      LAST: "Last"
    });
    return _this4;
  }

  (0, _createClass2.default)(MonthlyRecurrenceOptions, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          handlerFor = _this$props4.handlerFor,
          required = _this$props4.required,
          id = _this$props4.id,
          interval = _this$props4.interval,
          dayOfMonth = _this$props4.dayOfMonth,
          offset = _this$props4.offset,
          weekdays = _this$props4.weekdays,
          error = _this$props4.error,
          useRepeatEach = _this$props4.useRepeatEach;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        id: "".concat(id, "-recurrence-interval"),
        className: "prmbl-recurrence-interval",
        onChange: handlerFor("interval", true),
        required: required,
        value: interval,
        label: "Every X month(s)",
        type: "number",
        minValue: 1,
        error: error
      })), /*#__PURE__*/_react.default.createElement("div", null, "Repeat on", " ", /*#__PURE__*/_react.default.createElement(_Toggle.default, {
        id: "".concat(id, "-recurrence-repeat-toggle"),
        checked: useRepeatEach,
        onChange: handlerFor("useRepeatEach", false, function (e) {
          return e.target.checked;
        }),
        label: "Repeat on/each"
      }), " ", "each"), !useRepeatEach && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropDown.default, {
        id: "".concat(id, "-recurrence-monthly-pattern"),
        onChange: handlerFor("offset", false, function (x) {
          return x ? x.value : "First";
        }),
        value: offset,
        required: required,
        options: [{
          label: "First",
          value: "First"
        }, {
          label: "Second",
          value: "Second"
        }, {
          label: "Third",
          value: "Third"
        }, {
          label: "Fourth",
          value: "Fourth"
        }, {
          label: "Last",
          value: "Last"
        }],
        sortMenuOptions: false,
        label: "On the"
      }), /*#__PURE__*/_react.default.createElement(_DropDown.default, {
        id: "".concat(id, "-recurrence-monthly-pattern-day"),
        onChange: handlerFor("weekdays", false, function (x) {
          return x && x.value ? [x.value] : ["Sunday"];
        }),
        value: weekdays[0],
        required: required,
        options: [{
          label: "Sunday",
          value: "Sunday"
        }, {
          label: "Monday",
          value: "Monday"
        }, {
          label: "Tuesday",
          value: "Tuesday"
        }, {
          label: "Wednesday",
          value: "Wednesday"
        }, {
          label: "Thursday",
          value: "Thursday"
        }, {
          label: "Friday",
          value: "Friday"
        }, {
          label: "Saturday",
          value: "Saturday"
        }],
        sortMenuOptions: false
      })), useRepeatEach && /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        id: "".concat(id, "-recurrence-repeat-each"),
        onChange: handlerFor("dayOfMonth"),
        required: required,
        value: dayOfMonth,
        label: "Each",
        type: "number",
        minValue: 1,
        maxValue: 31,
        error: error
      }));
    }
  }]);
  return MonthlyRecurrenceOptions;
}(_react.default.Component);

(0, _defineProperty2.default)(MonthlyRecurrenceOptions, "propTypes", {
  /**
   * The offset for the recurrence
   */
  offset: _propTypes.default.oneOf(["First", "Second", "Third", "Fourth", "Last"]),

  /**
   * Day of month 1 - 31
   */
  dayOfMonth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The number of [days,weeks,months,years] between each occurrence for the recurrence.
   */
  interval: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /*
   * If true the recurrence options are required.
   */
  required: _propTypes.default.bool,

  /*
   *  A function that will create a handler to handle value changes given a name and optional value accessor. (name, valueAccessor) => value => {...}
   */
  handlerFor: _propTypes.default.func,

  /**
   * The selected weekdays for the recurrence.
   */
  weekdays: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Boolean whether there is an error from validation
   */
  error: _propTypes.default.bool,

  /**
   * Boolean whether to use the day of the month, or specify a day of the week and which week.
   */
  useRepeatEach: _propTypes.default.bool
});
(0, _defineProperty2.default)(MonthlyRecurrenceOptions, "defaultProps", {
  useRepeatEach: false
});

var YearlyRecurrenceOptions = /*#__PURE__*/function (_React$Component5) {
  (0, _inherits2.default)(YearlyRecurrenceOptions, _React$Component5);

  var _super5 = _createSuper(YearlyRecurrenceOptions);

  function YearlyRecurrenceOptions() {
    (0, _classCallCheck2.default)(this, YearlyRecurrenceOptions);
    return _super5.apply(this, arguments);
  }

  (0, _createClass2.default)(YearlyRecurrenceOptions, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          handlerFor = _this$props5.handlerFor,
          required = _this$props5.required,
          id = _this$props5.id,
          interval = _this$props5.interval,
          error = _this$props5.error;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        type: "number",
        min: 0,
        id: "".concat(id, "-recurrence-interval"),
        className: "prmbl-recurrence-interval",
        onChange: handlerFor("interval", true),
        required: required,
        value: interval,
        label: "Every X year(s)",
        minValue: 1,
        error: error
      }));
    }
  }]);
  return YearlyRecurrenceOptions;
}(_react.default.Component);

(0, _defineProperty2.default)(YearlyRecurrenceOptions, "propTypes", {
  /**
   * The number of [days,weeks,months,years] between each occurrence for the recurrence.
   */
  interval: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /*
   * If true the recurrence options are required.
   */
  required: _propTypes.default.bool,

  /*
   *  A function that will create a handler to handle value changes given a name and optional value accessor. (name, valueAccessor) => value => {...}
   */
  handlerFor: _propTypes.default.func,

  /**
   * Boolean whether there is an error from validation
   */
  error: _propTypes.default.bool
});
var _default = Recurrence;
exports.default = _default;